// extracted by mini-css-extract-plugin
export default {"outerWrapper":"Wrapper_outerWrapper__6IGTK","logo":"Wrapper_logo__cEX0O","wrapper":"Wrapper_wrapper__e9GUQ"};